{
    "form-listing": {
        "title": "Form Projects",
        "sort": "Sort",
        "sort-by": "Sort by",
        "order": "Order",
        "newest-first": "Newest first",
        "descending": "Descending",
        "oldest-first": "Oldest first",
        "ascending": "ascending",
        "tags": "Tags",
        "filter": "Filter:",
        "filter-name": "Name",
        "filter-createdAt": "Created At",
        "filter-updatedAt": "Updated At",
        "new-form": "New Form Project",
        "new-form-subtitle": "Design and Prototype",
        "import-form": "Import existing Project",
        "import-form-subtitle": "Import a \".xfe\" file",
        "edited": "Edited {{date}} ago"
    },
    "hub": {
        "navbar-logout": "Logout",
        "navbar-settings": "Settings…",
        "navItems": {
            "forms": "Forms",
            "logs": "Logs"
        }
    },
    "session-logs": {
        "title": "Logs",
        "filter": "Filter Projects",
        "no-logs": "No logs available",
        "more": "More",
        "item": {
            "submitted": "Submitted {{date}} ago",
            "session-info": "Session Data",
            "export": "Export this log"
        },
        "group": {
            "export": "Export all logs of this session"
        }
    },
    "app-settings": {
        "title": "Builder Settings",
        "locale": "Locale",
        "hotkeys": "Hotkeys"
    },
    "import-form": {
        "corrupted-error": "File could not be imported and might be corrupted.",
        "version-error": "File is was created in an older version of Form Engine",
        "importing": "Importing…",
        "success": "Import successful"
    }
}